module.exports = __webpack_public_path__ + "media/images/homes/IngridientManagement-44e130d8049061b6c1f867ff99a9abf3.png";